export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "r-v3/js/room-log-worker-src.b477c67d.worker.js");
}
